module.exports = __webpack_public_path__ + "img/img_004-100x90-2.ba17860b.png";